import { ApprovalableTypeEnum } from 'api-hooks/common';
import { ApprovalSVG } from 'common/assets';
import { Button } from 'components/elements/buttons';
import useDialog from 'hooks/use-dialog';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import RequestApprovalModal from './request-modal';

interface Props {
  data: {
    approvalableId: string;
    approvalableType: ApprovalableTypeEnum;
    workflow?: string | null;
  };

  onDismiss?: () => void;
}

export default function RequestApprovalButton(props: Props) {
  const { t } = useTranslation();
  const { data, onDismiss } = props;

  const dialog = useDialog();

  const onRequest = () => {
    dialog.showCustom({
      render: (onClose) => (
        <RequestApprovalModal
          onClose={onClose}
          data={data}
          onDismissSuccess={onDismiss}
        />
      ),
    });
  };

  return (
    <Button
      startEnhancer={(color, size) => <ApprovalSVG color={color} size={size} />}
      onClick={onRequest}
    >
      {t('common:request_approval')}
    </Button>
  );
}
